<template>
  <div class="text-center q-mt-xl" style="z-index: 10">
    <div class="text-primary text-bold q-mb-lg" style="font-size: 40px">
      {{ $t('error.notFound.404').toUpperCase() }}
    </div>

    <div class="text-h2">
      {{ $t('error.notFound.nothing') }}
    </div>

    <div class="row justify-center q-mt-lg">
      <div class="col-6 col-sm-3 col-lg-2">
        <svg-img image="server-down" color="primary" width="100%" />
      </div>
    </div>

    <q-btn
      class="q-mt-lg btn-lg"
      color="primary"
      to="/"
      :label="$t('error.notFound.backToHome')"
    />
  </div>
</template>

<script setup lang="ts">
import SvgImg from 'components/common/ui/svgImage/SvgImg.vue'
</script>
